import { render, staticRenderFns } from "./OzDrawerModal.vue?vue&type=template&id=1bb85e79&scoped=true&"
import script from "./OzDrawerModal.vue?vue&type=script&lang=ts&"
export * from "./OzDrawerModal.vue?vue&type=script&lang=ts&"
import style0 from "./OzDrawerModal.vue?vue&type=style&index=0&id=1bb85e79&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb85e79",
  null
  
)

export default component.exports